import React from 'react';
import Util from 'screens/shared/utilities';

export default ({ type, className = '' }) => {
  const iconsMap = { INGRESS: 'arrow-right', EGRESS: 'arrow-left', BIDIRECTIONAL: 'arrows-alt-h' };
  const colorsMap = { INGRESS: 'danger', EGRESS: 'base', BIDIRECTIONAL: 'success' };

  return (
    <Util.IconLabel colorsMap={colorsMap} iconsMap={iconsMap} label={type} className={className} />
  );
};
